import { useCallback, useState } from "react";
import { usePopper } from "react-popper";
import { useClickOutside } from "./useClickOutside";
export function useDesktopFilterPopover(placement) {
    const [open, setOpen] = useState(false);
    const [referenceEl, setReferenceEl] = useState(null);
    const [popperEl, setPopperEl] = useState(null);
    const { styles, attributes } = usePopper(referenceEl, popperEl, {
        strategy: "fixed",
        placement,
        modifiers: [
            { name: "flip", options: { padding: 8 } },
            { name: "preventOverflow", options: { padding: 8 } },
            { name: "offset", options: { offset: [0, 6] } },
        ],
    });
    const close = useCallback(() => setOpen(false), []);
    const toggle = useCallback(() => setOpen((value) => !value), []);
    useClickOutside(open, close, referenceEl, popperEl);
    return {
        open,
        close,
        toggle,
        setReferenceEl,
        setPopperEl,
        styles,
        attributes,
    };
}
